import { a11yProps, EstadoLiberarVentaENUM, sizeTab, texto } from "@/shared";
import { CustomTabPanel, SingleTableBoxScene } from "@/shared/components/ui";
import { Box, Tab, Tabs } from "@mui/material";
import { useState } from "react";
import TableSolicitudNuveaLineaCorporativo from "../../shared/componente/table_solicitud_nueva_inea_corporativo/TableSolicitudNuveaLineaCorporativo";

export default function SolicitudNuevaLineaCorporativoPage() {

  const [valueTab, setValueTab] = useState(0);

  return (
    <SingleTableBoxScene
      title={"Solicitud Nueva Línea Corporativo"}
      visibleReport={true}
    >
      <Box sx={{ bgcolor: 'background.paper', maxWidth: sizeTab, paddingBottom: 2 }} >
        <Tabs
          value={valueTab}
          onChange={(_event: React.SyntheticEvent, newValue: number) => {
            setValueTab(newValue);
          }}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          aria-label="scrollable force tabs preventa"
        >
          <Tab label={texto.solicitud} {...a11yProps(0)} />
          <Tab label={texto.aprobado} {...a11yProps(1)} />
          <Tab label={texto.rechazadas} {...a11yProps(2)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={valueTab} index={0}>
        <TableSolicitudNuveaLineaCorporativo />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={1}>
        <TableSolicitudNuveaLineaCorporativo
          enableEditing={false}
          showCustomActionBtnSpace={false}
          estadoLibreacion={EstadoLiberarVentaENUM.APROBADO}
        />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={2}>
        <TableSolicitudNuveaLineaCorporativo
          enableEditing={false}
          showCustomActionBtnSpace={false}
          estadoLibreacion={EstadoLiberarVentaENUM.CANCELADO}
        />
      </CustomTabPanel>

    </SingleTableBoxScene>

  );

}